import React           from 'react';
import { withRouter }  from 'react-router';
import * as Components from '../Components';
import uuidv4          from '../../utils/Uuid';

class _5050 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      map: this.props.map
    };
  }

  render() {
    const top = this.props.map._100.map((c) => {
      const Component = Components[c];
      return <Component key={uuidv4()} />;
    });
      
    const left = this.props.map._50left.map((c) => {
      const Component = Components[c];
      return <Component key={uuidv4()} />;
    });
    
    const right = this.props.map._50right.map((c) => {
      const Component = Components[c];
      return <Component key={uuidv4()} />;
    });
    
    return (
      <div>
        <div>{top}</div>
        <div class="row">
          <div class="col-xs-6">{left}</div>
          <div class="col-xs-6">{right}</div>
        </div> 
      </div>
    );
  }
}

export default withRouter(_5050);
